
    import './styles.scoped.css';
    export default {
  "alert": "awsui_alert_mx3cw_rxfvn_93",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_mx3cw_rxfvn_1",
  "root": "awsui_root_mx3cw_rxfvn_119",
  "hidden": "awsui_hidden_mx3cw_rxfvn_133",
  "body": "awsui_body_mx3cw_rxfvn_156",
  "header": "awsui_header_mx3cw_rxfvn_162",
  "action": "awsui_action_mx3cw_rxfvn_166",
  "action-button": "awsui_action-button_mx3cw_rxfvn_171",
  "text": "awsui_text_mx3cw_rxfvn_175",
  "icon": "awsui_icon_mx3cw_rxfvn_179",
  "message": "awsui_message_mx3cw_rxfvn_182",
  "breakpoint-default": "awsui_breakpoint-default_mx3cw_rxfvn_190",
  "content": "awsui_content_mx3cw_rxfvn_204",
  "dismiss": "awsui_dismiss_mx3cw_rxfvn_208",
  "dismiss-button": "awsui_dismiss-button_mx3cw_rxfvn_214",
  "type-error": "awsui_type-error_mx3cw_rxfvn_222",
  "type-warning": "awsui_type-warning_mx3cw_rxfvn_230",
  "type-success": "awsui_type-success_mx3cw_rxfvn_238",
  "type-info": "awsui_type-info_mx3cw_rxfvn_246"
};
  